<div
  class="carousel w-full m-auto relative pt-10"
  data-ride="carousel"
>
  <div class="carousel-inner pb-4 flex gap-x-3 items-stretch overflow-hidden relative w-full">
    <ng-container *ngFor="let card of cards">
      <ng-container
        *ngIf="
          cards.indexOf(card) >= currentIndex && cards.indexOf(card) < currentIndex + nbDisplayCards
        "
      >
        <ng-container *ngTemplateOutlet="carouselItem; context: { $implicit: card }"></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="cards?.length < nbDisplayCards">
      <ng-container *ngFor="let card of [].constructor(nbDisplayCards - cards?.length)">
        <div class="flex-1 items-stretch"></div>
      </ng-container>
    </ng-container>
  </div>
  <div class="absolute top-0 right-0">
    <app-rounded-icon-button
      [size]="'xs'"
      [disabled]="!currentIndex"
      [type]="'light'"
      [icon]="'icon-arrow-left'"
      (click)="prev()"
    ></app-rounded-icon-button>
    <app-rounded-icon-button
      class="ml-2"
      [disabled]="
        currentIndex === cards?.length - nbDisplayCards || nbDisplayCards >= cards?.length
      "
      [size]="'xs'"
      [type]="'light'"
      [icon]="'icon-arrow-right'"
      (click)="next()"
    ></app-rounded-icon-button>
  </div>
</div>
